<template>
    <button :type="type" class="inline-flex items-center py-2 px-4 bg-white border border-gray-300 font-semibold text-xs text-gray-700 uppercase tracking-widest hover:text-gray-500 hover:outline-0 active:outline-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-minplan-blue active:text-gray-800 active:bg-gray-50 disabled:opacity-25 transition whitespace-nowrap">
        <slot></slot>
    </button>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            type: {
                type: String,
                default: 'button',
            },
        }
    })
</script>
